import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid, Layers, GitBranch, Radio, ArrowRight, TrendingUp, Star, CheckCircle, Clock, PlusCircle, UserIcon, BookOpen, Bot, MessageSquare, Calendar, AlertCircle } from 'lucide-react';
const Dashboard = () => {
  return <div className="flex flex-col h-full" data-id="element-285">
      <div className="px-4 py-6 sm:px-6 lg:px-8 bg-white border-b" data-id="element-286">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-287">
          Professional Growth Dashboard
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-288">
          Your personalized growth insights and recommended actions
        </p>
      </div>
      <div className="flex-1 px-4 py-6 sm:px-6 lg:px-8 bg-gray-50" data-id="element-289">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-290">
          {/* Left column - Priority actions */}
          <div className="lg:col-span-2 space-y-6" data-id="element-291">
            {/* Priority actions card */}
            <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-292">
              <div className="px-4 py-5 sm:px-6 bg-blue-50 border-b border-blue-100" data-id="element-293">
                <div className="flex items-center justify-between" data-id="element-294">
                  <h2 className="text-lg font-medium text-blue-800" data-id="element-295">
                    Priority Actions
                  </h2>
                  <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full" data-id="element-296">
                    4 actions
                  </span>
                </div>
              </div>
              <div className="divide-y divide-gray-200" data-id="element-297">
                <div className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-298">
                  <div className="flex items-start" data-id="element-299">
                    <div className="flex-shrink-0 mt-1" data-id="element-300">
                      <div className="p-1 rounded-md bg-yellow-100" data-id="element-301">
                        <TrendingUp className="h-5 w-5 text-yellow-600" data-id="element-302" />
                      </div>
                    </div>
                    <div className="ml-4 flex-1" data-id="element-303">
                      <div className="flex items-center justify-between" data-id="element-304">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-305">
                          Improve TypeScript skills
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-306">
                          High impact
                        </span>
                      </div>
                      <div className="mt-1 text-sm text-gray-600" data-id="element-307">
                        Your TypeScript skills are at intermediate level with
                        high growth potential (25%)
                      </div>
                      <div className="mt-2 flex" data-id="element-308">
                        <Link to="/capacity" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-309">
                          View skill details
                          <ArrowRight className="ml-1 h-3 w-3" data-id="element-310" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-311">
                  <div className="flex items-start" data-id="element-312">
                    <div className="flex-shrink-0 mt-1" data-id="element-313">
                      <div className="p-1 rounded-md bg-green-100" data-id="element-314">
                        <UserIcon className="h-5 w-5 text-green-600" data-id="element-315" />
                      </div>
                    </div>
                    <div className="ml-4 flex-1" data-id="element-316">
                      <div className="flex items-center justify-between" data-id="element-317">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-318">
                          Connect with Jamie Taylor
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-319">
                          Cross-functional
                        </span>
                      </div>
                      <div className="mt-1 text-sm text-gray-600" data-id="element-320">
                        Product Manager - Recommended for cross-functional
                        collaboration
                      </div>
                      <div className="mt-2 flex" data-id="element-321">
                        <Link to="/branching" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-322">
                          View connection
                          <ArrowRight className="ml-1 h-3 w-3" data-id="element-323" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-324">
                  <div className="flex items-start" data-id="element-325">
                    <div className="flex-shrink-0 mt-1" data-id="element-326">
                      <div className="p-1 rounded-md bg-purple-100" data-id="element-327">
                        <MessageSquare className="h-5 w-5 text-purple-600" data-id="element-328" />
                      </div>
                    </div>
                    <div className="ml-4 flex-1" data-id="element-329">
                      <div className="flex items-center justify-between" data-id="element-330">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-331">
                          Respond to leadership mentoring request
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-332">87% match</span>
                      </div>
                      <div className="mt-1 text-sm text-gray-600" data-id="element-333">
                        Junior developer seeking guidance on leading their first
                        team project
                      </div>
                      <div className="mt-2 flex" data-id="element-334">
                        <Link to="/beacon" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-335">
                          View request
                          <ArrowRight className="ml-1 h-3 w-3" data-id="element-336" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-4 sm:px-6 hover:bg-gray-50" data-id="element-337">
                  <div className="flex items-start" data-id="element-338">
                    <div className="flex-shrink-0 mt-1" data-id="element-339">
                      <div className="p-1 rounded-md bg-blue-100" data-id="element-340">
                        <BookOpen className="h-5 w-5 text-blue-600" data-id="element-341" />
                      </div>
                    </div>
                    <div className="ml-4 flex-1" data-id="element-342">
                      <div className="flex items-center justify-between" data-id="element-343">
                        <h3 className="text-sm font-medium text-gray-900" data-id="element-344">
                          Explore Cloud Computing skills
                        </h3>
                        <span className="text-xs text-gray-500" data-id="element-345">
                          New opportunity
                        </span>
                      </div>
                      <div className="mt-1 text-sm text-gray-600" data-id="element-346">
                        Recommended based on your technical profile
                      </div>
                      <div className="mt-2 flex" data-id="element-347">
                        <Link to="/branching" className="text-xs text-blue-600 hover:text-blue-800 flex items-center" data-id="element-348">
                          Add to skills
                          <ArrowRight className="ml-1 h-3 w-3" data-id="element-349" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 py-3 bg-gray-50 border-t border-gray-200 text-right" data-id="element-350">
                <Link to="/agent" className="text-sm text-blue-600 hover:text-blue-800 flex items-center justify-end" data-id="element-351">
                  Get personalized recommendations
                  <ArrowRight className="ml-1 h-4 w-4" data-id="element-352" />
                </Link>
              </div>
            </div>
            {/* Recent activity */}
            <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-353">
              <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-354">
                <div className="flex items-center justify-between" data-id="element-355">
                  <h2 className="text-lg font-medium text-gray-900" data-id="element-356">
                    Recent Activity
                  </h2>
                  <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-800 rounded-full" data-id="element-357">
                    Last 7 days
                  </span>
                </div>
              </div>
              <div className="divide-y divide-gray-200" data-id="element-358">
                <div className="px-4 py-3 sm:px-6" data-id="element-359">
                  <div className="flex items-center" data-id="element-360">
                    <div className="flex-shrink-0" data-id="element-361">
                      <Clock className="h-4 w-4 text-gray-400" data-id="element-362" />
                    </div>
                    <div className="ml-3" data-id="element-363">
                      <p className="text-sm text-gray-600" data-id="element-364">
                        Used <span className="font-medium" data-id="element-365">JavaScript</span>{' '}
                        skill (2 days ago)
                      </p>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 sm:px-6" data-id="element-366">
                  <div className="flex items-center" data-id="element-367">
                    <div className="flex-shrink-0" data-id="element-368">
                      <CheckCircle className="h-4 w-4 text-green-500" data-id="element-369" />
                    </div>
                    <div className="ml-3" data-id="element-370">
                      <p className="text-sm text-gray-600" data-id="element-371">
                        Responded to{' '}
                        <span className="font-medium" data-id="element-372">
                          Product Requirements Clarification
                        </span>{' '}
                        request
                      </p>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 sm:px-6" data-id="element-373">
                  <div className="flex items-center" data-id="element-374">
                    <div className="flex-shrink-0" data-id="element-375">
                      <Star className="h-4 w-4 text-yellow-500" data-id="element-376" />
                    </div>
                    <div className="ml-3" data-id="element-377">
                      <p className="text-sm text-gray-600" data-id="element-378">
                        Improved <span className="font-medium" data-id="element-379">Leadership</span>{' '}
                        skill level
                      </p>
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 sm:px-6" data-id="element-380">
                  <div className="flex items-center" data-id="element-381">
                    <div className="flex-shrink-0" data-id="element-382">
                      <PlusCircle className="h-4 w-4 text-blue-500" data-id="element-383" />
                    </div>
                    <div className="ml-3" data-id="element-384">
                      <p className="text-sm text-gray-600" data-id="element-385">
                        Connected with{' '}
                        <span className="font-medium" data-id="element-386">Alex Johnson</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Right column - Stats and quick access */}
          <div className="space-y-6" data-id="element-387">
            {/* Growth stats */}
            <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-388">
              <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-389">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-390">
                  Growth Stats
                </h2>
              </div>
              <div className="p-6" data-id="element-391">
                <div className="grid grid-cols-2 gap-4" data-id="element-392">
                  <div className="bg-blue-50 rounded-lg p-4 text-center" data-id="element-393">
                    <div className="text-3xl font-bold text-blue-600" data-id="element-394">12</div>
                    <div className="text-sm text-gray-600 mt-1" data-id="element-395">Skills</div>
                  </div>
                  <div className="bg-green-50 rounded-lg p-4 text-center" data-id="element-396">
                    <div className="text-3xl font-bold text-green-600" data-id="element-397">7</div>
                    <div className="text-sm text-gray-600 mt-1" data-id="element-398">
                      Connections
                    </div>
                  </div>
                  <div className="bg-purple-50 rounded-lg p-4 text-center" data-id="element-399">
                    <div className="text-3xl font-bold text-purple-600" data-id="element-400">3</div>
                    <div className="text-sm text-gray-600 mt-1" data-id="element-401">Responses</div>
                  </div>
                  <div className="bg-yellow-50 rounded-lg p-4 text-center" data-id="element-402">
                    <div className="text-3xl font-bold text-yellow-600" data-id="element-403">
                      15%
                    </div>
                    <div className="text-sm text-gray-600 mt-1" data-id="element-404">Growth</div>
                  </div>
                </div>
              </div>
            </div>
            {/* Quick access */}
            <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-405">
              <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-406">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-407">
                  Quick Access
                </h2>
              </div>
              <div className="p-4" data-id="element-408">
                <div className="grid grid-cols-2 gap-3" data-id="element-409">
                  <Link to="/agent" className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-blue-50 hover:border-blue-200 transition-colors" data-id="element-410">
                    <LayoutGrid className="h-6 w-6 text-blue-600 mb-2" data-id="element-411" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-412">
                      Growth Agent
                    </span>
                  </Link>
                  <Link to="/capacity" className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-blue-50 hover:border-blue-200 transition-colors" data-id="element-413">
                    <Layers className="h-6 w-6 text-blue-600 mb-2" data-id="element-414" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-415">
                      Capacity
                    </span>
                  </Link>
                  <Link to="/branching" className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-blue-50 hover:border-blue-200 transition-colors" data-id="element-416">
                    <GitBranch className="h-6 w-6 text-blue-600 mb-2" data-id="element-417" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-418">
                      Branching
                    </span>
                  </Link>
                  <Link to="/beacon" className="flex flex-col items-center justify-center p-4 border rounded-lg hover:bg-blue-50 hover:border-blue-200 transition-colors" data-id="element-419">
                    <Radio className="h-6 w-6 text-blue-600 mb-2" data-id="element-420" />
                    <span className="text-sm font-medium text-gray-900" data-id="element-421">
                      Beacon
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            {/* Upcoming */}
            <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-422">
              <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-423">
                <h2 className="text-lg font-medium text-gray-900" data-id="element-424">Upcoming</h2>
              </div>
              <div className="divide-y divide-gray-200" data-id="element-425">
                <div className="px-4 py-3 sm:px-6 flex items-start" data-id="element-426">
                  <div className="flex-shrink-0 mt-1" data-id="element-427">
                    <Calendar className="h-4 w-4 text-gray-400" data-id="element-428" />
                  </div>
                  <div className="ml-3" data-id="element-429">
                    <p className="text-sm font-medium text-gray-900" data-id="element-430">
                      TypeScript Workshop
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-431">
                      Tomorrow, 2:00 PM
                    </p>
                  </div>
                </div>
                <div className="px-4 py-3 sm:px-6 flex items-start" data-id="element-432">
                  <div className="flex-shrink-0 mt-1" data-id="element-433">
                    <Calendar className="h-4 w-4 text-gray-400" data-id="element-434" />
                  </div>
                  <div className="ml-3" data-id="element-435">
                    <p className="text-sm font-medium text-gray-900" data-id="element-436">
                      Mentoring Session
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-437">
                      Friday, 11:00 AM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Dashboard;